document.addEventListener('DOMContentLoaded', function() {
  // Only run on mobile
  if (window.innerWidth > 767) return;

  const carousel = document.querySelector('.mobile-product-carousel');
  if (!carousel) return;

  const slidesContainer = carousel.querySelector('.mobile-carousel-slides');
  const slides = carousel.querySelectorAll('.mobile-carousel-slide');
  const dots = carousel.querySelectorAll('.mobile-carousel-dot');
  let currentSlide = 0;

  function goToSlide(index) {
    currentSlide = index;
    slidesContainer.style.transform = `translateX(-${index * 100}%)`;

    // Update dots
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });
  }

  // Dot navigation
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => goToSlide(index));
  });

  // Touch/swipe support
  let startX = 0;
  let startY = 0;
  let isDragging = false;

  carousel.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isDragging = true;
  });

  carousel.addEventListener('touchend', (e) => {
    if (!isDragging) return;
    isDragging = false;

    const endX = e.changedTouches[0].clientX;
    const endY = e.changedTouches[0].clientY;
    const diffX = startX - endX;
    const diffY = Math.abs(startY - endY);

    // Only swipe if horizontal movement is greater than vertical (not scrolling)
    if (Math.abs(diffX) > 50 && Math.abs(diffX) > diffY) {
      if (diffX > 0 && currentSlide < slides.length - 1) {
        goToSlide(currentSlide + 1);
      } else if (diffX < 0 && currentSlide > 0) {
        goToSlide(currentSlide - 1);
      }
    }
  });
});